module.exports = __webpack_public_path__ + "static/media/articles.2b0cd4ed.svg";